// Leaf property names (relative to `creditApp.owners[N].`) considered PG/guarantor-only data.
export const PERSONAL_GUARANTOR_FIELD_NAMES = new Set<string>([
  'ownerPgId',
  'creditApplicationId',
  'firstName',
  'lastName',
  'ownerPercentage',
  'ssn',
  'title',
  'dateOfBirth',
  'address',
  'city',
  'state',
  'postalCode',
  'driversLicenseNum',
  'dlStateIssued',
  'ownerNumber',
  'homeType',
  'homePhone',
  'phone',
  'timeAtAddressYears',
  'timeAtAddressMonths',
  'netWorth',
  'grossMonthlyIncome',
  'monthlyHousingPayment',
  'employerName',
  'timeAtJobYears',
  'timeAtJobMonths',
  'mobilePhone',
  'signature',
  'signatureTitle',
  'signatureDate',
  'dlUploaded',
  'email',
  'yearsWithCdl',
  'usCitizen',
  'pg',
  'pcOnly',
  'isCreditReportPulling',
  'personalGuarantor.personalGuarantorId',
  'personalGuarantor.personalGuarantorDynamicsId',
  'personalGuarantor.personalGuarantorName',
  'personalGuarantor.mostRecentCbrs',
]);
